import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import services from '@C/Director/Packages/_utils/data';
import { set } from 'lodash';

const settings = {
  dots: false,
  arrows: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
};

const Subscription = () => {
  const history = useHistory();
  const location = useLocation();
  const formData = location.state?.formData;
  const [currentPlan, setCurrentPlan] = useState('monthly');
  const [features, setFeatures] = useState([]);
  const [listVisible, setListVisible] = useState(false);
  const [activePackage, setActivePackage] = useState(null);

  const [plans, setPlans] = useState([]);
  const [selectedDurations, setSelectedDurations] = useState({});

  const handleSubmit = () => {
    // get trian plan uuid from features
    const trialPlanID = plans.find((plan) => plan.name === 'TRIAL')
      .plan_structure[0].uuid;
    history.push('/register', {
      formData,
      structure_id: trialPlanID,
      plan_name: 'TRIAL',
    });
  };

  const handleDurationChange = (planName, duration) => {
    setSelectedDurations((prev) => ({ ...prev, [planName]: duration }));
  };

  const handlePlanSelect = (selectedPlan) => {
    const selectedStructure = selectedPlan.plan_structure.find(
      (struct) =>
        struct.plan_type.toLowerCase() === selectedDurations[selectedPlan.name],
    );

    if (selectedStructure) {
      history.push('/register', { structure_id: selectedStructure.uuid });
    }
  };

  useEffect(() => {
    getPackages();
    getAllFeatures();
  }, []);

  const getAllFeatures = () => {
    services
      .getAllFeatures()
      .then((response) => {
        const data = response.data.data.map((feature) => ({
          name: feature.module,
          uuid: feature.uuid,
        }));
        setFeatures(data);
      })
      .catch((error) => {
        console.error('Error fetching features:', error);
      });
  };

  const getPackages = () => {
    services
      .getPackages()
      .then((response) => {
        const data = response.data.data.map((plan) => ({
          name: plan.plan,
          description: plan.notes,
          plan_structure: plan.plan_structure,
          prices: plan.plan_structure.reduce((acc, item) => {
            acc[item.plan_type.toLowerCase()] = item.price;
            return acc;
          }, {}),
          features: plan.packages.map((item) => ({
            name: item.module,
            available: true,
          })),
        }));
        setPlans(data);
        const defaultDurations = data.reduce((acc, plan) => {
          acc[plan.name] = 'monthly';
          return acc;
        }, {});
        setSelectedDurations(defaultDurations);
      })
      .catch((error) => {
        console.error('Error fetching plans:', error);
      });
  };

  return (
    <div className="subscription-container">
      <div className="subscription-plans">
        <div className="subscription-header">
          <h1>Subscription Plans</h1>
          <div className="plan-switcher">
            <button
              className={currentPlan === 'monthly' ? 'active' : ''}
              onClick={() => setCurrentPlan('monthly')}
            >
              Monthly
            </button>
            <button
              className={currentPlan === 'quarterly' ? 'active' : ''}
              onClick={() => setCurrentPlan('quarterly')}
            >
              Quarterly
            </button>
            <button
              className={currentPlan === 'yearly' ? 'active' : ''}
              onClick={() => setCurrentPlan('yearly')}
            >
              Yearly
            </button>
            <div className="highlighter"></div>
          </div>
        </div>
        <div className="subscription-content">
          <div className="features-container">
            <div className="features">
              <h3>Features</h3>
              <ul>
                {features.map((feature) => (
                  <li
                    key={feature.uuid}
                    className={`${listVisible ? 'list-visible' : ''}`}
                  >
                    {feature.name}
                  </li>
                ))}
              </ul>
              <button
                className="show-more"
                onClick={() => setListVisible(!listVisible)}
              >
                {listVisible ? 'Show Less' : 'Show More'}
              </button>
            </div>
          </div>
          <Slider {...settings} className="plan-container">
            {plans.map((plan) => (
              <div
                className={`plan-item ${activePackage === plan.name ? 'active' : ''}`}
                key={plan.name}
                onClick={() => setActivePackage(plan.name)}
              >
                <h3>
                  {plan.name} {plan.tag && <span>({plan.tag})</span>}
                </h3>
                <p>{plan.description}</p>

                <div className="price-box">
                  <div className="price-wrapper">
                    ${plan.prices[currentPlan] || 'N/A'}
                    <span>
                      {currentPlan === 'monthly' && '/month'}
                      {currentPlan === 'quarterly' && '/quarter'}
                      {currentPlan === 'yearly' && '/year'}
                    </span>
                  </div>
                </div>
                <div className="plan-features">
                  <ul>
                    {features.map((feature) => {
                      const isAvailable = plan.features.some(
                        (planFeature) => planFeature.name === feature.name,
                      );

                      return (
                        <li
                          key={feature.uuid}
                          className={`${listVisible ? 'list-visible' : ''}`}
                        >
                          <span
                            className={`availablity ${isAvailable ? 'available' : 'unavailable'}`}
                          ></span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div className="plan-actions">
                  <button
                    className="submit"
                    onClick={() => handlePlanSelect(plan)}
                  >
                    Select Plan
                  </button>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div className="cta-wrapper">
          <button className="submit" onClick={handleSubmit}>
            Continue with Free trial
          </button>
        </div>
      </div>
    </div>
  );
};

export { Subscription };
